







































import { Component, Vue } from 'vue-property-decorator';
import { MonthlyReport } from '../common/form-type.interface';
import MonthYear from '../components/MonthYear.vue';
import Img from '../components/Image.vue';

import utility from '../common/utility';

@Component({
    components: {
        MonthYear,
        Img
    }
})
export default class extends Vue {
    public monthlyReport: MonthlyReport = {
        month: 0,
        year: 2020,
        weeklyMeeting: {
            isValid: false,
            data: {
                hadMeeting: 'no',
                noMeetingRemarks: '',
                meetings: [
                    {
                        date: '',
                        totalPresent: '',
                        teachingTopic: '',
                        preacher: '',
                        remarks: '',
                        id: 0
                    }
                ]
            }
        },
        coreTeamMeeting : {
            isValid: false,
            data: {
                hadMeeting: 'no',
                noMeetingRemarks: '',
                meetings: [
                    {
                        id: 0,
                        date: '',
                        pointsDiscussed: ''
                    }
                ]
            }
        },
        otherMinistryMeeting: {
            isValid: false,
            data: {
                hadMeeting: 'no',
                noMeetingRemarks: '',
                meetings: [
                    {
                        id: 0,
                        date: '',
                        totalPeople: '',
                        remarks: ''
                    }
                ]
            }
        },
        discipleshipCellMeeting: {
            isValid: false,
            data: {
                hadMeeting: 'no',
                noMeetingRemarks: '',
                meetings: [
                    {
                        id: 0,
                        date: '',
                        totalPeople: '',
                        remarks: ''
                    }
                ]
            }
        },
        otherActivities: {
            isValid: true,
            data: {
                prayerGroupActivity: '',
                zonalActivity: '',
                numOfFamiliesVisited: ''
            }
        }
    };

    public setMonthYear(event: MonthYear) {
        this.monthlyReport.month = event.month;
        this.monthlyReport.year = event.year;

        utility.eventBus.$emit('data', { type: 'monthYear', data: event });
    }

    private created() {
        const monthlyReport = utility.getData();

        const now = new Date();

        this.monthlyReport.month = now.getMonth() + 1;
        this.monthlyReport.year = now.getFullYear();

        if ( monthlyReport ) {
            this.monthlyReport = monthlyReport;
        }

        utility.eventBus.$on('data', (type: any) => {
            utility.persistData(this.monthlyReport, type);
        });
    }
}
